// Tamaño de texto elegible por el usuario ("Cómo se ve MiPAE", 2026-09-08,
// segunda fila de TemaSelector).
//
// Por qué esto existe: es accesibilidad para la enfermera en turno (noche,
// lentes, guantes), no decoración. La familia de letra queda para después.
//
// Por qué NO `zoom` ni cambiar el `font-size` de `html`: la densidad global
// de 14.4px (index.css) es la base de TODOS los rem de espaciado de la app;
// tocarla movería también el espaciado, los altos, `100vh`, las barras fijas
// y `useTecladoAbierto`. El método es una variable `--texto-escala` en
// <html> que SOLO multiplica los `fontSize` de Tailwind (tailwind.config.js,
// bloque `esc()`/`escRem()`); el espaciado y los altos quedan intactos.
//
// Por qué Compacto (0.92) no puede bajar los campos de iOS de 16px: bajo ese
// umbral iOS hace zoom al enfocar un campo y no vuelve (vacuna de
// index.css). La regla de esa vacuna usa `max(16px, calc(16px *
// var(--texto-escala, 1)))`, así que un usuario con Compacto sigue viendo
// sus campos a 16px reales aunque el resto del texto se vea más chico.

export const TEXTO_DEFAULT = 'normal';
export const CLAVE_TEXTO = 'mipae_texto';

export const TAMANOS = [
  { id: 'compacto', nombre: 'Compacto', escala: 0.92 },
  { id: 'normal', nombre: 'Normal', escala: 1 },
  { id: 'grande', nombre: 'Grande', escala: 1.12 },
  { id: 'muy-grande', nombre: 'Muy grande', escala: 1.25 },
];

export function textoHabilitado() {
  return process.env.REACT_APP_TEXTO_ENABLED !== 'false';
}

export function tamanoPorId(id) {
  return TAMANOS.find((t) => t.id === id) || null;
}

// jsonb/localStorage adulterado jamás rompe: cualquier valor fuera del
// catálogo cae al default.
export function normalizarTexto(id) {
  return tamanoPorId(id) ? id : TEXTO_DEFAULT;
}

export function escalaDe(id) {
  const normalizado = normalizarTexto(id);
  return tamanoPorId(normalizado).escala;
}

export function leerTexto() {
  if (!textoHabilitado()) return TEXTO_DEFAULT;
  try {
    return normalizarTexto(localStorage.getItem(CLAVE_TEXTO));
  } catch {
    return TEXTO_DEFAULT;
  }
}

export function guardarTexto(id) {
  const normalizado = normalizarTexto(id);
  try {
    localStorage.setItem(CLAVE_TEXTO, normalizado);
  } catch { /* noop: localStorage caído no debe romper el ajuste */ }
  return normalizado;
}

// Aplica (o limpia) la variable --texto-escala sobre <html>. Con el default
// ('normal', escala 1) o el flag apagado, LIMPIA la variable para que el
// cálculo `calc(N * var(--texto-escala, 1))` caiga al 1 implícito sin
// residuo de una elección previa. Devuelve la escala aplicada, o null si se
// limpió.
export function aplicarTextoEnDocumento(id, { root } = {}) {
  try {
    const elemento = root || document.documentElement;
    const normalizado = textoHabilitado() ? normalizarTexto(id) : TEXTO_DEFAULT;
    const escala = escalaDe(normalizado);

    if (normalizado === TEXTO_DEFAULT) {
      elemento.style.removeProperty('--texto-escala');
      return null;
    }

    elemento.style.setProperty('--texto-escala', String(escala));
    return escala;
  } catch {
    return null;
  }
}
